import type {NfServiceWorkerCommunication} from "@/services/NfServiceWorkerCommunication";
import {NfMessageType} from "@/serviceWorker/workerComponents/NfMessage";
import {SetStandardFilters} from "@/serviceWorker/workerComponents/MessageTypes/SetStandardFilters";
import {uniq} from "lodash-es";
import type {StandardFilterConfig} from "@/frontendClasses";
import {initialStandardFilterConfig} from "@/frontendClasses/StandardFilterConfig";

/**
 * Ten serwis zajmuje się obsługą listy ulubionych standardów
 * W komponentach pobieraj go z injecta
 */
export class NfFavoritesService {
    declare private communication: NfServiceWorkerCommunication;
    private widgetId: number;
    private standardFilters: StandardFilterConfig;
    private __v_skip = true;

    constructor(widgetId: number) {
        this.widgetId = widgetId;
        this.standardFilters = initialStandardFilterConfig;
        this.standardFilters.favoriteRoomStandardIds = this.getFavorites();
    }
    initialize(communication: NfServiceWorkerCommunication) {
        this.communication = communication;
        this.communication.getMessageObservable(NfMessageType.SetStandardFilters).subscribe(message => {
            if (message instanceof SetStandardFilters) {
                this.standardFilters = message.filters;
            }
        });
    }

    private saveFavorites(roomStandardIds: number[]) {
        this.standardFilters.favoriteRoomStandardIds = roomStandardIds;

        this.communication.sendMessage(new SetStandardFilters(
            this.communication.getComponentId(),
            this.standardFilters
        ));

        window.localStorage.setItem(this.getStorageKey(), JSON.stringify(roomStandardIds));
    }

    private getStorageKey() {
        return 'nfhotel-favorites-' + this.widgetId;
    }

    public getFavorites(): number[] {
        const savedFavorites = window.localStorage.getItem(this.getStorageKey());
        if (savedFavorites) {
            return JSON.parse(savedFavorites);
        } else {
            return [];
        }
    }

    addFavorite(roomStandardId: number): void {
        const favorites = this.getFavorites();
        favorites.push(roomStandardId);

        this.saveFavorites(uniq(favorites));
    }

    removeFavorite(roomStandardId: number): void {
        const favorites = this.getFavorites();

        this.saveFavorites(favorites.filter(r => r != roomStandardId));
    }
}